import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

export class DatenverwaltungBereiche extends React.Component<{}, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
        this.validateField = this.validateField.bind(this);
    }

    @lazyInject(TriggerService) private triggerService: TriggerService;

    render(): JSX.Element {
        return (
            <WFormsTableWrapper
                entity={IDs.ENT_BRANCHEN_BEREICHE}
                module={IDs.MOD_ETOOL_ADMIN}
                actions={['add', 'edit', 'delete']}
                customClass='Custom-ETA'
                formLayout='flowV2'
                validateField={this.validateField}
                onSaveDone={() => this.triggerService.fire('admin_reload', IDs.ENT_BRANCHEN_BEREICHE)}
                showColumnsHelp
            />
        );
    }

    validateField(key: string, value: any): string {
        let message: string = null;

        if (key === 'email' && (value || '').toString().trim().length) {
            value.split(';').forEach((email: string) => {
                const regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                email = email.trim();

                if (!regex.test(email.toLowerCase())) {
                    message = `E-Mail-Adresse [${email}] ist ungültig`;
                }
            });
        }

        return message;
    }
}
